import axios from 'axios'

// 创建axios实例
const service = axios.create({
  baseURL: "https://yzoa.5gwind.cn", 
  timeout: 15000, // 请求超时时间
  credentials: 'omit'
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在发送请求前做些什么
    const token = localStorage.getItem('token') || ''
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}` // 设置请求头token
    }
    
    // 可以在这里统一处理请求参数，例如表单数据格式化
    if (config.method === 'post' && config.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
      config.data = qs.stringify(config.data) // 需要安装qs库
    }
    
    return config
  },
  error => {
    // 对请求错误做些什么
    console.log('请求拦截器错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 2xx 范围内的状态码都会触发该函数
    const res = response.data
    
    // 根据后端返回的code做不同处理
    // if (res.code === 200 || res.success) {
    if (res.code == 0) {
      return res
    } else {
      // 处理业务错误
      if (res.code === 401) {
        // token过期处理
        MessageBox.confirm('登录已过期，请重新登录', '提示', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('user/resetToken').then(() => {
            location.reload()
          })
        })
      } else if (res.code === 403) {
        Message({
          message: '没有权限访问该资源',
          type: 'error',
          duration: 3 * 1000
        })
      } else {
        Message({
          message: res.message || '请求失败',
          type: 'error',
          duration: 3 * 1000
        })
      }
      
      return Promise.reject(new Error(res.message || '请求失败'))
    }
  },
  error => {
    // 超出2xx范围的状态码都会触发该函数
    let errorMessage = '请求失败'
    
    if (error.message.includes('timeout')) {
      errorMessage = '请求超时，请检查网络'
    } else if (error.response) {
      // 服务器返回了非2xx的状态码
      switch (error.response.status) {
        case 401:
          errorMessage = '认证失败，请重新登录'
          // 这里可以触发登出操作
          break
        case 403:
          errorMessage = '拒绝访问'
          break
        case 404:
          errorMessage = '请求地址不存在'
          break
        case 500:
          errorMessage = '服务器内部错误'
          break
        default:
          errorMessage = `请求错误 ${error.response.status}`
      }
    } else {
      // 没有收到服务器响应
      errorMessage = '网络连接异常，请检查网络'
    }
    
    Message({
      message: errorMessage,
      type: 'error',
      duration: 5 * 1000
    })
    
    return Promise.reject(error)
  }
)

export default service